import * as Yup from 'yup';

import { type FieldSchema, type ValidatorContext } from '../types';

const createBooleanValidator = (context: ValidatorContext): FieldSchema => {
  const { field, l, isRequired, requiredMessage } = context;

  let validator = Yup.mixed().nullable();

  if (isRequired && 'isReadOnly' in field && !field.isReadOnly) {
    const message = requiredMessage ?? l('This field is required');

    validator = validator.test('boolean-required', message, (value) => {
      // null/undefined means the field was never interacted with — fail required
      if (value === null || value === undefined) {
        return false;
      }

      // true or false are both valid explicit choices
      if (typeof value === 'boolean') {
        return true;
      }

      if (typeof value === 'string') {
        const s = value.trim().toLowerCase();

        return s === 'true' || s === '1' || s === 'false' || s === '0';
      }

      return false;
    });
  }

  return validator;
};

export default createBooleanValidator;
